import React from 'react';
import { Box, Grid2 as Grid, Typography } from '@mui/material';

type ContactSectionProps = {
  title: string;
  subtitle?: string;
  description: React.ReactNode;
  children: React.ReactNode;
};

const ContactSection: React.FC<ContactSectionProps> = ({ title, subtitle, description, children }) => {
  return (
    <Grid container spacing={4} sx={{ flex: 1 }}>
      <Grid size={{ xs: 12, md: 5.5 }}>
        <Typography variant="h5" component="h2" color="secondary" mb={2}>
          {title}
        </Typography>
        {children}
      </Grid>
      <Grid size={{ xs: 12, md: 6.5 }}>
        <Typography variant="body1" color="textSecondary" mb={2} mt={1}>
          {subtitle}
        </Typography>
        <Box mb={3}>{description}</Box>
      </Grid>
    </Grid>
  );
};

export default ContactSection;
